import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

export const asyncRoutes = []

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/indexv2'),
    hidden: true
  },

  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    meta: { key: 'root', permission: 'admin' },
    children: [{
      path: 'index',
      name: '工作台',
      component: () => import('@/views/admin/dashboard/index'),
      meta: { title: '工作台', icon: 'dashboard', key: 'index' }
    }]
  },
  {
    path: '/my',
    component: Layout,
    redirect: '/my',
    meta: { key: 'my', permission: 'ent' },
    children: [{
      path: '/my',
      name: '个人中心',
      component: () => import('@/views/enterprise/user/index'),
      meta: { title: '个人中心', icon: 'el-icon-info', key: 'index' }
    }]
  },
  {
    path: '/enterprise',
    component: Layout,
    name: '企业管理',
    redirect: '/enterprise/index',
    meta: { title: '企业管理', key: 'enterprise', icon: 'el-icon-office-building', permission: 'admin' },
    children: [{
      path: 'index',
      name: '待审核列表',
      component: () => import('@/views/admin/enterprise/index'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '待审核列表', icon: 'el-icon-edit', key: 'enterprise-index' }
    }, {
      path: 'search/:id',
      name: '企业搜索',
      component: () => import('@/views/admin/enterprise/search'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '企业搜索', icon: 'el-icon-search', key: 'enterprise-search' }
    }]
  },
  {
    path: '/admin_demand',
    component: Layout,
    name: '供需对接管理',
    redirect: '/admin_demand/demands',
    meta: { title: '供需对接管理', key: 'admin_demand', icon: 'el-icon-star-on', permission: 'admin' },
    children: [{
      path: 'demands',
      name: '企业供需列表',
      component: () => import('@/views/admin/demand/index'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '企业供需列表', icon: 'el-icon-office-building', key: 'admin_demand-demands' }
    }, {
      path: 'edit/:id',
      name: 'admin-demand-edit',
      component: () => import('@/views/admin/demand/edit'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      hidden: true,
      meta: { title: '编辑供需', icon: 'el-icon-edit', key: 'admin_demand-demands-edit' }
    }, {
      path: 'match',
      name: '已匹配申请列表',
      component: () => import('@/views/admin/demand/match'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '已匹配申请列表', icon: 'el-icon-connection', key: 'admin_demand-match' }
    }, {
      path: 'view-apply/:demand_id',
      name: '查看申请',
      component: () => import('@/views/admin/demand/apply'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      hidden: true,
      meta: { title: '查看申请', icon: 'el-icon-document', key: 'admin_demand-view-apply' }
    }]
  },
  {
    path: '/banner',
    component: Layout,
    name: '轮播图管理',
    redirect: '/banner/index',
    meta: { title: '轮播图管理', key: 'banner', icon: 'el-icon-picture-outline', permission: 'admin' },
    children: [{
      path: 'edit',
      name: '添加轮播图',
      component: () => import('@/views/admin/banner/edit'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '添加轮播图', icon: 'el-icon-edit', key: 'banner-add' }
    }, {
      path: 'edit/:id',
      name: '添加轮播图',
      component: () => import('@/views/admin/banner/edit'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      hidden: true,
      meta: { title: '添加轮播图', icon: 'el-icon-edit', key: 'banner-edit' }
    }, {
      path: 'index',
      name: '轮播图列表',
      component: () => import('@/views/admin/banner/index'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '轮播图列表', icon: 'el-icon-picture-outline', key: 'banner-index' }
    }]
  },
  {
    path: '/bcwq',
    component: Layout,
    name: 'bcwq',
    redirect: '/bcwq/index',
    meta: { title: '百场万企', key: 'activity', icon: 'el-icon-document', permission: 'admin' },
    children: [{
      path: 'index',
      name: 'bcwq.index',
      component: () => import('@/views/admin/activity/bcwq/index'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '专场列表', icon: 'el-icon-document', key: 'activity-bcwq-index' }
    }, {
      path: 'edit',
      name: 'bcwq.edit',
      component: () => import('@/views/admin/activity/bcwq/edit'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '添加专场', icon: 'el-icon-edit', key: 'activity-bcwq-edit' }
    }, {
      path: 'edit/:id',
      name: 'edit',
      component: () => import('@/views/admin/activity/bcwq/edit'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      hidden: true,
      meta: { title: '修改专场', icon: 'el-icon-edit', key: 'activity-bcwq-edit' }
    }, {
      path: 'effect/score',
      name: 'effect.score',
      component: () => import('@/views/admin/activity/bcwq/effect/score'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      hidden: false,
      meta: { title: '成效汇总', icon: 'el-icon-document', key: 'activity-bcwq-score', permission: 'ministerial' }
    }, {
      path: 'applies/:activity_id',
      name: 'edit',
      component: () => import('@/views/admin/activity/bcwq/applies'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      hidden: true,
      meta: { title: '专场申请列表', icon: 'el-icon-edit', key: 'activity-bcwq-edit' }
    }, {
      path: 'effect/index',
      name: 'bcwq.effect.index',
      component: () => import('@/views/admin/activity/bcwq/effect/index'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '成效专区', icon: 'el-icon-document', key: 'activity-bcwq-effect-index' }
    },  {
      path: 'effect/adminscore',
      name: 'bcwq.effect.index',
      component: () => import('@/views/admin/activity/bcwq/effect/adminscore'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '成效专区(管理员)', icon: 'el-icon-document', key: 'activity-bcwq-effect-index', permission: 'ministerial' }
    }, {
      path: 'effect/edit',
      name: 'activity.bcwq.effect.edit',
      component: () => import('@/views/admin/activity/bcwq/effect/edit'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '编写成效表', icon: 'el-icon-edit', key: 'activity-bcwq-effect-edit' }
    },
      {
        path: 'effect/edit/:id',
        name: 'activity.bcwq.effect.edit',
        component: () => import('@/views/admin/activity/bcwq/effect/edit'),
        noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
        affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
        hidden: true,
        meta: { title: '修改成效表', icon: 'el-icon-edit', key: 'activity-bcwq-effect-edit' }
      }]
  },
  {
    path: '/jbgs',
    name: 'jbgs',
    component: Layout,
    meta: { title: '发榜揭榜', icon: 'el-icon-document', key: 'jbgs', permission: 'admin' },
    redirect: '/jbgs/index',
    children: [
      {
        path: 'index',
        name: 'jbgs.index',
        component: () => import('@/views/admin/activity/jbgs/index2024'),
        noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
        affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
        meta: { title: '大企业发榜列表', icon: 'el-icon-document', key: 'jbgs-index' }
      }, {
        path: 'applies',
        name: 'jbgs.edit',
        component: () => import('@/views/admin/activity/jbgs/applies'),
        noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
        affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
        meta: { title: '揭榜列表', icon: 'el-icon-document', key: 'jbgs-edit' }
      }, {
        path: 'list',
        name: '揭榜',
        component: () => import('@/views/admin/demand/list'),
        noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
        affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
        hidden: true,
        meta: { title: '揭榜总览', icon: 'el-icon-s-flag', key: 'admin_demand-demands-list' }
      }, {
        path: 'edit',
        name: 'activity.jbgs.edit',
        component: () => import('@/views/admin/activity/jbgs/edit'),
        noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
        affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
        meta: { title: '添加需求', icon: 'el-icon-edit', key: 'activity-jbgs-edit' }
      }]
  },
  {
    path: '/activity',
    component: Layout,
    name: 'activity',
    redirect: '/activity/index',
    meta: { title: '活动管理', key: 'activity', icon: 'el-icon-document', permission: 'admin' },
    children: [{
      path: 'edit',
      name: 'activity.edit',
      component: () => import('@/views/admin/activity/edit'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '添加站点活动', icon: 'el-icon-edit', key: 'activity-add' }
    }, {
      path: 'edit/:id',
      name: 'activity.edit',
      component: () => import('@/views/admin/activity/edit'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      hidden: true,
      meta: { title: '添加站点活动', icon: 'el-icon-edit', key: 'activity-edit' }
    }, {
      path: 'index',
      name: 'activity.index',
      component: () => import('@/views/admin/activity/index'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '站点活动列表', icon: 'el-icon-document', key: 'activity-index' }
    }]
  },
  {
    path: '/article',
    component: Layout,
    name: '文章管理',
    redirect: '/article/index',
    meta: { title: '文章管理', key: 'article', icon: 'el-icon-document', permission: 'admin' },
    children: [{
      path: 'edit',
      name: '添加文章',
      component: () => import('@/views/admin/article/edit'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '添加文章', icon: 'el-icon-edit', key: 'article-add' }
    }, {
      path: 'edit/:id',
      name: '添加文章',
      component: () => import('@/views/admin/article/edit'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      hidden: true,
      meta: { title: '添加文章', icon: 'el-icon-edit', key: 'article-edit' }
    }, {
      path: 'index',
      name: '文章列表',
      component: () => import('@/views/admin/article/index'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '文章列表', icon: 'el-icon-document', key: 'article-index' }
    }]
  },
  {
    path: '/area',
    component: Layout,
    name: '地域管理',
    redirect: '/area/index',
    meta: { title: '地域管理', key: 'area', icon: 'el-icon-position', permission: 'admin' },
    children: [{
      path: 'edit',
      name: '添加地域',
      component: () => import('@/views/admin/area/edit'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '添加地域', icon: 'el-icon-edit', key: 'area-add' }
    }, {
      path: 'edit/:id',
      name: '添加地域',
      component: () => import('@/views/admin/area/edit'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      hidden: true,
      meta: { title: '添加地域', icon: 'el-icon-position', key: 'area-edit' }
    }, {
      path: 'index',
      name: '地域列表',
      component: () => import('@/views/admin/area/index'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '地域列表', icon: 'el-icon-picture-outline', key: 'area-index' }
    }]
  },
  {
    path: '/system',
    component: Layout,
    name: '系统设置',
    redirect: '/system/user/index',
    meta: { title: '系统设置', key: 'article', icon: 'el-icon-setting', permission: 'supper' },
    children: [{
      path: 'user/edit',
      name: '添加管理员',
      component: () => import('@/views/admin/system/adduser'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '添加管理员', icon: 'el-icon-edit', key: 'system-user-add' }
    }, {
      path: 'user',
      name: '管理员管理',
      component: () => import('@/views/admin/system/user'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '管理员管理', icon: 'el-icon-document', key: 'article-edit' }
    }]
  },
  {
    path: '/collect',
    component: Layout,
    name: '征集活动管理',
    redirect: '/collect/index',
    meta: { title: '系统设置', key: 'article', icon: 'el-icon-setting', permission: 'supper' },
    children: [{
      path: 'index',
      name: '征集活动一期',
      component: () => import('@/views/admin/collect/index'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '征集活动一期', icon: 'el-icon-document', key: 'collect-index' }
    }]
  },
  {
    path: '/activity_applies',
    component: Layout,
    name: 'enterprise-activity',
    redirect: '/enterprise/activity_applies/index',
    meta: { title: '揭榜管理', key: 'demand', icon: 'el-icon-office-building',permission: 'ent' },
    children: [ {
      path: 'index',
      name: 'enterprise-activity-index',
      component: () => import('@/views/enterprise/activity_applies/index2025'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '揭榜列表', icon: 'el-icon-document', key: 'demand-index' }
    }, {
      path: 'edit',
      name: 'jbgs-edit',
      component: () => import('@/views/enterprise/activity_applies/jbgs/join2024'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '修改揭榜对接表', icon: 'el-icon-document', key: 'jbgs-join' }
    }]
  },
  {
    path: '/demand',
    component: Layout,
    name: '对接供需管理',
    redirect: '/demand/index',
    hidden: true,
    meta: { title: '对接供需管理', key: 'demand', icon: 'el-icon-office-building', permission: 'ent' },
    children: [{
      path: 'edit/:id',
      name: '编辑事项',
      component: () => import('@/views/enterprise/demand/edit'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      hidden: true,
      meta: { title: '编辑事项', icon: 'el-icon-edit', key: 'demand-edit' }
    }, {
      path: 'edit',
      name: 'enterprise-demand-edit',
      component: () => import('@/views/enterprise/demand/edit'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '发布对接事项', icon: 'el-icon-edit', key: 'demand-add' }
    }, {
      path: 'index',
      name: 'enterprise-demand-index',
      component: () => import('@/views/enterprise/demand/index'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '对接事项列表', icon: 'el-icon-document', key: 'demand-index' }
    }, {
      path: 'view-apply/:demand_id',
      name: '查看申请',
      component: () => import('@/views/enterprise/demand/apply'),
      hidden: true,
      meta: { title: '查看申请', icon: 'el-icon-document', key: 'demand-view-apply' }
    }, {
      path: 'apply/index',
      name: '我的申请',
      component: () => import('@/views/enterprise/apply/index'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '我的申请', icon: 'el-icon-document', key: 'apply-index' }
    }, {
      path: 'recommends/:id',
      name: '系统匹配',
      hidden: true,
      component: () => import('@/views/enterprise/demand/recommend'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '系统匹配', icon: 'el-icon-document', key: 'recommend-index' }
    }, {
      path: 'apply/edit/:id',
      name: '编辑申请',
      hidden: true,
      component: () => import('@/views/enterprise/apply/edit'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '编辑申请', icon: 'el-icon-document', key: 'apply-edit' }
    }]
  },
  {
    path: '/ent/activity/jbgs',
    component: Layout,
    name: '发榜',
    redirect: '/ent/activity/jbgs/index',
    meta: { title: '发榜管理', key: 'demand', icon: 'el-icon-office-building',permission: 'ent' },
    children: [{
      path: 'edit/:id',
      name: '编辑需求',
      component: () => import('@/views/enterprise/activity/edit'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      hidden: true,
      meta: { title: '编辑需求', icon: 'el-icon-edit', key: 'demand-edit' }
    }, {
      path: 'edit',
      name: '发布需求',
      component: () => import('@/views/enterprise/activity/edit'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '发布需求', icon: 'el-icon-edit', key: 'demand-edit' }
    }, {
      path: 'index',
      name: 'enterprise-activity-jbgs-edit',
      component: () => import('@/views/enterprise/activity/index2024'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '已发布需求列表', icon: 'el-icon-document', key: 'activity-index2024' }
    }, {
      path: 'applies/:activity_id',
      name: 'enterprise-activity-jbgs-applies',
      component: () => import('@/views/enterprise/activity/applies'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      hidden: true,
      meta: { title: '申请列表', icon: 'el-icon-document', key: 'activity-index2024' }
    }]
  },

  {
    path: '/join',
    component: Layout,
    name: '我要加入',
    hidden: true,
    meta: { title: '我要加入', key: 'join', icon: 'el-icon-office-building', permission: 'small' },
    children: [{
      path: ':id',
      name: '我有意愿',
      hidden: true,
      component: () => import('@/views/enterprise/apply/join'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '我有意愿', icon: 'el-icon-document', key: 'apply-edit' }
    }]
  },
  // {
  //   path: '/collect',
  //   component: Layout,
  //   name: '征集活动',
  //   hidden: false,
  //   meta: { title: '我要加入', key: 'join', icon: 'el-icon-office-building', permission: 'ent' },
  //   children: [{
  //     path: 'recommend/join',
  //     name: '专精特新产品征集活动',
  //     hidden: false,
  //     component: () => import('@/views/enterprise/collect/recommend/join'),
  //     noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
  //     affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
  //     meta: { title: '专精特新产品征集活动', icon: 'el-icon-document', key: 'collect-recommend-join' }
  //   }]
  // },
  {
    path: '/activity/join',
    component: Layout,
    name: 'activity-join',
    hidden: true,
    meta: { title: '我要参加', key: 'join', icon: 'el-icon-office-building' },
    children: [{
      path: 'bcwq/:activity_id',
      name: 'bcwq-join',
      hidden: true,
      component: () => import('@/views/enterprise/activity_applies/bcwq/join'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '百场万企申请表', icon: 'el-icon-document', key: 'bcwq-join' }
    }, {
      path: 'jbgs/:activity_id',
      name: 'jbgs-join',
      hidden: true,
      component: () => import('@/views/enterprise/activity_applies/jbgs/join2024'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '发榜揭榜申请表', icon: 'el-icon-document', key: 'jbgs-join' }
    }, {
      path: 'bcwq/:activity_id/:id',
      name: 'bcwq-join',
      hidden: true,
      component: () => import('@/views/enterprise/activity_applies/bcwq/join'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '百场万企申请表', icon: 'el-icon-document', key: 'bcwq-join' }
    }, {
      path: 'jbgs/:activity_id/:id',
      name: 'jbgs-join',
      hidden: true,
      component: () => import('@/views/enterprise/activity_applies/jbgs/join2024'),
      noCache: true, // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
      affix: true, // 如果设置为true，它则会固定在tags-view中(默认 false)
      meta: { title: '发榜揭榜申请表', icon: 'el-icon-document', key: 'jbgs-join' }
    }]
  },
  {
    path: process.env.VUE_APP_BASE_URL + '/dbossfront',
    name: '其他对接事项',
    hidden: true,
    meta: { title: '其他企业对接事项', key: 'join', icon: 'el-icon-edit-outline', permission: 'ent' },
    children: []
  },
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
